import { P, match } from 'ts-pattern';

import { DEFAULT_RINGTONE, RingtoneNames, TRingtoneNames } from '@cloud-wave/neon-common-lib/app';

export const isRingtoneEnum = (value: string | undefined): value is TRingtoneNames => {
  return value !== undefined && Object.values(RingtoneNames).includes(value as TRingtoneNames);
};

export const getDefaultRingtoneName = ({
  ringtone,
  adminRingtone,
  hasRestrictedRingtonePermission,
}: {
  ringtone: TRingtoneNames | undefined;
  adminRingtone: TRingtoneNames | undefined;
  hasRestrictedRingtonePermission: boolean;
}) => {
  return (
    match({
      ringtone,
      adminRingtone,
      hasRestrictedRingtonePermission,
    })
      .returnType<TRingtoneNames>()
      //Restricted ringtone: use adminRingtone else DEFAULT_RINGTONE
      .with(
        { hasRestrictedRingtonePermission: true, adminRingtone: P.string },
        ({ adminRingtone }) => RingtoneNames[adminRingtone]
      )
      .with({ hasRestrictedRingtonePermission: true }, () => RingtoneNames[DEFAULT_RINGTONE])
      // Non-restricted ringtone: use agent ringtone over adminRingtone if available, else DEFAULT_RINGTONE
      .with(
        {
          hasRestrictedRingtonePermission: false,
          ringtone: P.string,
        },
        ({ ringtone }) => RingtoneNames[ringtone]
      )
      .with(
        { hasRestrictedRingtonePermission: false, adminRingtone: P.string },
        ({ adminRingtone }) => RingtoneNames[adminRingtone]
      )
      .with({ hasRestrictedRingtonePermission: false }, () => RingtoneNames[DEFAULT_RINGTONE])
      .exhaustive()
  );
};
